import { render, staticRenderFns } from "./aiRecognition.vue?vue&type=template&id=efc56596&scoped=true"
import script from "./aiRecognition.vue?vue&type=script&lang=js"
export * from "./aiRecognition.vue?vue&type=script&lang=js"
import style0 from "./aiRecognition.vue?vue&type=style&index=0&id=efc56596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc56596",
  null
  
)

export default component.exports